import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { Breadcrumbs, EmptyState, Layout, Text } from '@loadsmart/loadsmart-ui'
import { Stack } from '@loadsmart/miranda-react'

import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { resolveShipmentsListPath } from './resolveShipmentsListPath'

export function EmptyShipmentPageState() {
  const history = useHistory()
  const { pathname } = useLocation()
  const shipmentsListUrl = resolveShipmentsListPath(pathname)

  const handleBackToShipperLoads = useCallback(() => {
    history.push(shipmentsListUrl)
  }, [history, shipmentsListUrl])

  const breadcrumbEntries = useMemo(
    () => [
      {
        label: 'Shipper Loads',
        url: `#${shipmentsListUrl}`,
      },
    ],
    [shipmentsListUrl]
  )

  return (
    <Stack>
      <Breadcrumbs onBack={handleBackToShipperLoads} entries={breadcrumbEntries} />
      <Layout.Stack space="m" align="center">
        <EmptyState
          illustration={IllustrationDepartingTruck}
          title="Oops! Nothing here."
          description="Looks like the page you're looking for does not exist or is not available anymore."
          variant="page"
        />
        <Text variant="body-bold">
          Go to our carrier platform and find spot loads to keep your truck full
        </Text>
      </Layout.Stack>
    </Stack>
  )
}
